<template>
  <div class="position-absolute bg-white z-2 w-100 main-menu overflow-hidden">
    <div class="container position-relative d-flex flex-column h-100">
      <button
        class="btn-close position-absolute top-0 end-0 mx-3 my-4 p-2 rounded-circle border bg-white d-none d-lg-block"
        type="button"
        @click="close"
      />

      <a
        v-if="!is_main"
        class="d-md-none clickable h5 dropdown-item d-block mt-1"
        @click.stop.prevent="open_link()"
        ><icon name="ARROW_LEFT" /> {{ translations.actions.SHOW_ALL }}</a
      >
      <div class="row h-100">
        <div
          v-if="!is_main"
          class="col order-lg-last overflow-scroll overscroll-contain no-scrollbar h-100"
        >
          <div
            v-if="!main_descendants && !is_main"
            class="w-100 h-100 text-center"
          >
            <div class="spinner-border muted m-5 p-5" />
          </div>
          <results v-if="main_descendants" :pages="main_descendants" />
        </div>
        <div
          class="col-12 col-lg-3 overflow-scroll overscroll-contain no-scrollbar h-100 border-end g-0 me-2"
        >
          <div
            v-if="megamenu_content"
            :class="{ 'd-none d-lg-flex': main_descendants }"
          >
            <filters
              :action="open_link"
              class="mt-4 w-100"
              :filters="megamenu_filters"
              :selected="url"
            />
          </div>
          <div
            v-if="html_content"
            class="w-100 d-flex flex-column d-lg-none mb-4 ms-3"
            v-html="html_content"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { filter, first, length, map, merge } from "@pdfking/rfunc"
import icon from "@pdfking/workflow/components/icon"
import fire_event from "@pdfking/workflow/utils/fire_event"
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import autocomplete from "../../constants/autocomplete"
import breadcrumbs from "../../constants/breadcrumbs"
import selector from "../../dom/selector"
import close from "../../mixins/close"
import freeze from "../../mixins/freeze"
import navigate from "../navigate"
import { NAV_VIEW } from "../urls"
import filters from "./layout/filters.vue"
import results from "./layout/results.vue"

export default {
  components: { filters, icon, results },
  computed: merge(
    proxy(autocomplete, [
      "pages_index",
      "pages_descendants_by_url",
      "pages_by_url",
    ]),
    {
      html_content() {
        return map((e: HTMLElement) => e.innerHTML, selector(this.html_selector)).join("")
      },
      is_main() {
        return !this.url
      },
      main_descendants() {
        if (this.url && this.pages_by_url && this.pages_by_url[this.url]) {
          let array = this.descendants(this.url)
          if (array && this.limit) {
            array = array.slice(0, this.limit)
          }
          return map(
            (o: any) =>
              merge(o, {
                descendants: this.descendants(o.url),
              }),
            array
          )
        }
      },
      megamenu_content() {
        return map(
          (e: HTMLElement) => ({ title: e.innerHTML, url: e.getAttribute("href") }),
          filter((e: HTMLElement) => e.innerHTML, selector(this.megamenu_selector))
        )
      },
      megamenu_filters() {
        return map(
          (el: any) => ({ id: el.url, title: el.title }),
          this.megamenu_content
        )
      },
      translations: () => make_translations("actions"),
    }
  ),
  data() {
    return {
      html_selector: ".main-offcanvas",
      megamenu_selector: ".main-megamenu[href]:not(.menu-0y6hmbho)",
      toggled_class: "search-body",
    }
  },
  methods: {
    descendants(url: string) {
      if (url && this.pages_descendants_by_url) {
        return filter(
          (p: any) => p.in_navigation,
          this.pages_descendants_by_url[url] || []
        )
      }
      return []
    },

    length,
    open_link(url?: string) {
      navigate(NAV_VIEW, url ? { url } : {})
    },
  },
  mixins: [close, freeze],
  async mounted() {
    fire_event(document, "focus_search")
    if (this.url === "auto") {
      for (const url of breadcrumbs.links) {
        for (const { url: cmp } of this.megamenu_content) {
          if (url === cmp) {
            return this.open_link(url)
          }
        }
      }
      return this.open_link(first(this.megamenu_content).url)
    }
  },

  props: ["url", "title"] as const,
}
</script>

<style lang="css">
.main-menu .dropdown-header {
  padding-top: 1rem;
  margin-top: 1rem;
}
.main-menu .dropdown-item {
  padding-top: 0.25rem;
  margin-top: 0.25rem;
}
.main-menu .megamenu-hide {
  display: none;
}
</style>
